module.exports = __webpack_public_path__ + "static/media/free-robot.84625c11.jpeg";